<template>
  <div>
    <CRow>
      <CCol col="12 col-sm-8">
        <CCard>
          <CCardHeader>
            لیست ویژگی اضافی
          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">
                <td>
                  <p class="text-muted">{{ index + 1 }}</p>
                </td>
              </template>
              <template #title="{item}">
                <td>
                  <p class="text-muted">{{item.option.title}}</p>
                </td>
              </template>


              <template #operation="{item}">
                <td class="py-2">

                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="delete_dialog(item)"
                  ><CIcon name="cil-trash" size="sm"/>
                  </CButton>
                </td>
              </template>


            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
      <CCol col="12 col-sm-4">
        <CCard>
          <CCardHeader>
            <strong>ثبت ویژگی جدید</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">

                <CSelect
                    :value.sync="selected_option"
class="required"
                    :options="options_list"
                    label="انتخاب ویژگی"
                />
              </CCol>

            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton
                @click="login()"
                type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
             {{status_form==0 ? 'ثبت ویژگی' : 'ویرایش ویژگی' }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>



  </div>

</template>

<script>
import axios from "@/api/http";
import {bus} from "../../../main";


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

      name: '',
      type: 1,
      type_list:[
          {label:'چک باکس',value:1,has_multiple_value:false},
          {label:'منو کشویی',value:2,has_multiple_value:true},
          {label:'دکمه رادیویی',value:3,has_multiple_value:true}
      ],

      summary:'',
      price:'0',
      items: [],
      options_list: [],
      selected_option: 0,
      fields: [
        {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'title',label: 'نام', _style: 'width:10%'},
        {key: 'operation', _style: 'width:40%;'},
      ],
      status_form: 0
    }
  }, mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
    this.get_options();
  }, watch: {},
  methods: {

    get_options() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_additional_options', formData, {}).then(function (response) {


        self.options_list = self.sort_array([{label:'انتخاب کنید',value:0}],response.data.tags,'id','title')

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append('product_id', this.$route.params.id);

      axios.post('/api/admin/product/get_additional_option_relations', formData, {}).then(function (response) {
        self.items = response.data

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    login() {

if(this.selected_option==0){
  return false;
}
      let self = this;
      const formData = new FormData()
      let url;
        url = "/api/admin/product/add_additional_option_relation";

      formData.append('selected_option', this.selected_option);
      formData.append('product_id', this.$route.params.id);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_additional_option_relation";

      formData.append('product_id', this.$route.params.id);

      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.get_categories();

      })
          .catch(function (error) {

            console.log(error);
          });
    },


  }
}


</script>
